import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";
import { Helmet } from "react-helmet";
import moment from "moment";
import store from "./store";
import LandingPage from "./components/landingpage/home";
import CarFinding from "./components/car/selfdrive/carfinding";
import CarFindingWD from "./components/car/withdriver/carfinding";
import TripDetail from "./components/trip/tripdetail";
import LoginPage from "./components/login/loginpage";
import ResetPw from "./components/login/resetpassword";
import Profile from "./components/profile/profile";
import Account from "./components/account/account";
import CarDetail from "./components/car/cardetail";
// import SignUp from "./components/account/signup"
import CarRegister from "./components/carowner/carregister";
import CarRegisterMode from "./components/carowner/carregisterMode";
import HowItWorks from "./components/tutorial/howitworks";
import PaymentHowTo from "./components/tutorial/paymenthowto";
import BookingHowTo from "./components/tutorial/bookinghowto";

import OwnerGuide from "./components/tutorial/ownerguide";
import AboutUs from "./components/tutorial/aboutus";
import WhyUs from "./components/tutorial/whyus";
import Features from "./components/tutorial/features";
// import CarRegisHowTo from "./components/tutorial/carregishowto"
// import RenterHowTo from "./components/tutorial/renterhowto"
import RenterBenefit from "./components/tutorial/renterbenefit";
import OwnerBenefit from "./components/tutorial/ownerbenefit";
import OwnerHowTo from "./components/tutorial/ownerhowto";
import CommingSoon from "./components/commingsoon";
import NotFound from "./components/common/notfound";
import MyCars from "./components/account/mycars";
import MyFavs from "./components/account/myfavs";
import MyTrips from "./components/account/mytrips";
import MyPromo from "./components/account/mypromo";
import MyCard from "./components/account/mycard";
import MyAddress from "./components/account/myaddress";
import DeleteAccount from "./components/account/deleteaccount";
import MyReward from "./components/reward/myreward";
import Privacy from "./components/tutorial/privacy";
import Terms from "./components/tutorial/terms";
import Faqs from "./components/tutorial/faqs";
import FaqsDetail from "./components/tutorial/faqsdetail";
import Regulation from "./components/tutorial/regulation";
import PersonalInfo from "./components/tutorial/personalinfo";
import ResolveConflic from "./components/tutorial/resolveconflic";
import SupportNav from "./components/tutorial/supportnav";
import Blogs from "./components/blog/blogs";
import Blog from "./components/blog/blog";
import CarSetting from "./components/carowner/carsetting";
// import CommonSetting from "./components/carowner/commonsetting"
import Calendars from "./components/carowner/calendars";
// import ShareCode from "./components/account/sharecode"
import City from "./components/city/city";
import Payment from "./components/trip/payment";
import CarsGPS from "./components/carowner/carsgps";
import CarsGPSSleep from "./components/carowner/carsgpssleep";
import MyWallet from "./components/carowner/mywallet";
import MyMonthlyReport from "./components/carowner/mymonthlyreport";
import OwnerRegister from "./components/carowner/ownerregister";
import B2BRegister from "./components/b2b/enterpriseregister";
import GPSRegister from "./components/gps/register";
import IframeSearching from "./components/landingpage/integrate3rd";
import InsuranceHome from "./components/insurance/home";

import InsuranceRegister from "./components/insurance/register";
import TNDSRegister from "./components/insurance/tndsregister";
import Contract from "./components/carowner/contract";
// import ContractSD from "./components/carowner/contractsd";
// import ContractWD from "./components/carowner/contractwd";
import Career from "./components/common/career";

import CSFinding from "./components/carsubscription/searching/csfinding";
import CSDetail from "./components/carsubscription/detail/csdetail";
import CSTrip from "./components/carsubscription/trip/cstrip";

import * as ROUTES from "./constant/routes";

/* FIREBASE PERFORMANCE START */
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getPerformance } from "firebase/performance";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: "AIzaSyAvQiuo0Tq7EELxSVXpDUlCmRfCVoluCdk",
	authDomain: "mioto-1.firebaseapp.com",
	databaseURL: "https://mioto-1.firebaseio.com",
	projectId: "mioto-1",
	storageBucket: "mioto-1.appspot.com",
	messagingSenderId: "123965734033",
	appId: "1:123965734033:web:688c39b68352fdc2369330",
	measurementId: "G-ZYXJJRHCTB",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);
export const perf = getPerformance(app);
/* FIREBASE PERFORMANCE END */

const App = () => {
	//localize the calendar in app
	moment.locale("vn", {
		months: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
			"_"
		),
		monthsShort: "Th. 1_Th. 2_Th. 3_Th. 4_Th. 5_Th. 6_Th. 7_Th. 8_Th. 9_TH. 10_Th. 11._Th. 12.".split("_"),
		monthsParseExact: true,
		weekdays: "Chủ nhật_Thứ 2_Thứ 3_Thứ 4_Thứ 5_Thứ 6_Thứ 7".split("_"),
		weekdaysShort: "CN_T. 2_T. 3_T. 4_T. 5_T. 6._T. 7".split("_"),
		weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"),
		weekdaysParseExact: true,
		longDateFormat: {
			LT: "HH:mm",
			LTS: "HH:mm:ss",
			L: "DD/MM/YYYY",
			LL: "D MMMM YYYY",
			LLL: "D MMMM YYYY HH:mm",
			LLLL: "dddd D MMMM YYYY HH:mm",
		},
		calendar: {
			sameDay: "[Cùng ngày] LT",
			nextDay: "[Ngày mai] LT",
			nextWeek: "dddd [Tuần tới] LT",
			lastDay: "[Hôm qua] LT",
			lastWeek: "dddd [Tuần rồi] LT",
			sameElse: "L",
		},
		relativeTime: {
			future: "%s tới",
			past: "%s trước",
			s: "%d giây",
			m: " 1 phút",
			mm: "%d phút",
			h: " 1 giờ",
			hh: "%d giờ",
			d: " 1 ngày",
			dd: "%d ngày",
			M: " 1 tháng",
			MM: "%d tháng",
			y: " 1 năm",
			yy: "%d năm",
		},
		dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
		ordinal: function (number) {
			return number + (number === 1 ? "er" : "e");
		},
		meridiemParse: /PD|MD/,
		isPM: function (input) {
			return input.charAt(0) === "M";
		},
		// In case the meridiem units are not separated around 12, then implement
		// this function (look at locale/id.js for an example).
		// meridiemHour : function (hour, meridiem) {
		//     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
		// },
		meridiem: function (hours, minutes, isLower) {
			return hours < 12 ? "AM" : "PM";
		},
		week: {
			dow: 1, // Monday is the first day of the week.
			doy: 4, // The week that contains Jan 4th is the first week of the year.
		},
	});

	return (
		<React.Fragment>
			<Provider store={store}>
				<BrowserRouter>
					<LastLocationProvider watchOnlyPathname={true}>
						<Switch>
							<Route exact path={ROUTES.HOME} component={LandingPage} />
							<Route exact path="/home" component={LandingPage} />
							<Route path={ROUTES.CITY} render={(props) => <City {...props} />} />
							<Route path={ROUTES.CITY_WD} render={(props) => <City {...props} />} />
							<Route path={ROUTES.CAR_FINDING} render={(props) => <CarFinding {...props} />} />
							<Route path={ROUTES.CAR_FINDING_WD} render={(props) => <CarFindingWD {...props} />} />
							<Route path={ROUTES.LOGIN} component={LoginPage} />

							<Route path={ROUTES.RESET_PW} component={ResetPw} />
							{/* <Route path='/cms' component={CommingSoon} />*/}

							<Route path={ROUTES.OWNER_REGISTER} component={OwnerRegister} />
							<Route path={ROUTES.GPS_REGISTER} component={GPSRegister} />

							<Route path={ROUTES.PROFILE} component={Profile} />
							<Route path={ROUTES.ACCOUNT} component={Account} />

							<Route exact path={ROUTES.CAR_DETAIL} render={(props) => <CarDetail {...props} />} />
							<Route exact path={ROUTES.CAR_DETAIL_WD} render={(props) => <CarDetail {...props} />} />
							<Route path={ROUTES.PAYMENT} render={(props) => <Payment {...props} />} />

							<Route exact path={ROUTES.TRIP_DETAIL} render={(props) => <TripDetail {...props} />} />

							<Route path={ROUTES.MY_CARS} component={MyCars} />
							<Route path={ROUTES.MY_FAVS} component={MyFavs} />
							<Route path={ROUTES.MY_TRIPS} component={MyTrips} />
							<Route path={ROUTES.MY_REWARD} component={MyReward} />
							<Route path={ROUTES.MY_ADDRESS} component={MyAddress} />
							<Route path={ROUTES.DELETE_ACCOUNT} component={DeleteAccount} />

							<Route path={ROUTES.MY_WALLET} component={MyWallet} />
							<Route path={ROUTES.MY_MONTHLY_REPORT} render={(props) => <MyMonthlyReport {...props} />} />
							<Route exact path={ROUTES.CAR_REGISTER} component={CarRegister} />
							<Route path={ROUTES.MODE_REGISTER} component={CarRegisterMode} />
							<Route path={ROUTES.CAR_SETTING} render={(props) => <CarSetting {...props} />} />
							<Route exact path={ROUTES.CONTRACT} component={Contract} />
							{/* <Route path={ROUTES.CONTRACT_SD} component={ContractSD} /> */}
							{/* <Route path={ROUTES.CONTRACT} component={ContractWD} /> */}
							<Route path={ROUTES.CALENDARS} component={Calendars} />

							<Route exact path={ROUTES.GPS} component={CarsGPS} />
							<Route path={ROUTES.GPS_SLEEP} component={CarsGPSSleep} />
							<Route exact path={ROUTES.INSURANCE} component={InsuranceHome} />
							<Route exact path={ROUTES.INSURANCE_REGISTER} component={InsuranceRegister} />
							<Route exact path={ROUTES.INSURANCE_TNDS} component={TNDSRegister} />

							{/*
							<Route path="/mycard" component={MyCard} />
							<Route path="/sharedcode" component={SharedCode} />
										
							<Route exact path="/promo" component={MyPromo} />
							<Route path="/promo/:code" render={props => <MyPromo {...props} />} />

							<Route path="/ownerguide" component={OwnerGuide} />
							<Route path="/ownerguide/mobile" component={OwnerGuide} />
							<Route path="/support" component={SupportNav} />
							
							
							<Route path="/features" component={Features} />
							<Route path="/ownerhowto" component={OwnerHowTo} />
							<Route path="/carregishowto" component={CarRegisHowTo} />
							<Route path="/ownerbenef" component={OwnerBenefit} />
							<Route path="/renterhowto" component={RenterHowTo} />
							<Route path="/renterbenef" component={RenterBenefit} />
							*/}

							<Route path={ROUTES.BOOKING_HOW_TO} component={BookingHowTo} />
							<Route path={ROUTES.M_BOOKING_HOW_TO} component={BookingHowTo} />
							<Route path={ROUTES.MOMO_BOOKING_HOW_TO} component={BookingHowTo} />
							<Route path={ROUTES.FAQS} component={Faqs} />
							<Route path={ROUTES.M_FAQS} component={Faqs} />
							<Route path={ROUTES.SUPPORT_APP} component={Faqs} />
							<Route path={ROUTES.R_FAQS} component={Faqs} />
							<Route exact path={ROUTES.FAQ_DETAIL} render={(props) => <FaqsDetail {...props} />} />
							<Route exact path={ROUTES.M_FAQ_DETAIL} render={(props) => <FaqsDetail {...props} />} />
							<Route exact path={ROUTES.R_FAQ_DETAIL} render={(props) => <FaqsDetail {...props} />} />
							<Route path={ROUTES.PAYMENT_HOW_TO} component={PaymentHowTo} />
							<Route path={ROUTES.M_PAYMENT_HOW_TO} component={PaymentHowTo} />
							<Route exact path={ROUTES.ABOUT_US} component={AboutUs} />
							<Route exact path={ROUTES.M_ABOUT_US} component={AboutUs} />
							{/* <Route exact path={ROUTES.WHY} component={WhyUs} />
							<Route exact path={ROUTES.M_WHY} component={WhyUs} /> */}
							<Route path={ROUTES.HOW_IT_WORK} component={HowItWorks} />
							<Route path={ROUTES.M_HOW_IT_WORK} component={HowItWorks} />
							<Route path={ROUTES.REGU} component={Regulation} />
							<Route path={ROUTES.M_REGU} component={Regulation} />
							<Route path={ROUTES.PERSONAL_INFO} component={PersonalInfo} />
							<Route path={ROUTES.M_PERSONAL_INFO} component={PersonalInfo} />
							<Route path={ROUTES.RESOLVE_CONFLIC} component={ResolveConflic} />
							<Route path={ROUTES.M_RESOLVE_CONFLIC} component={ResolveConflic} />
							<Route path={ROUTES.TERMS} component={Terms} />
							<Route path={ROUTES.M_TERMS} component={Terms} />
							<Route path={ROUTES.PRIVACY} component={Privacy} />
							<Route path={ROUTES.M_PRIVACY} component={Privacy} />
							<Route path={ROUTES.BLOGS} component={Blogs} />
							<Route exact path={ROUTES.BLOG_DETAIL_ID} component={Blog} />
							<Route exact path={ROUTES.BLOG_DETAIL_TITLE} component={Blog} />
							<Route path="/integrate/:integrate" render={(props) => <IframeSearching {...props} />} />

							<Route path={ROUTES.CAREER} component={Career} />

							<Route path={ROUTES.CS_FINDING} component={CSFinding} />
							<Route path={ROUTES.CS_DETAIL}  render={(props) => <CSDetail {...props} />}/>
							<Route path={ROUTES.CS_TRIPS} component={CSTrip} />

							<Route component={NotFound} />
						</Switch>
					</LastLocationProvider>
				</BrowserRouter>
			</Provider>
			<Helmet>
				<script type="text/javascript"></script>
			</Helmet>
		</React.Fragment>
	);
};

export default App;
